import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "element-ui/lib/theme-chalk/base.css";
import {
  Carousel,
  CarouselItem,
  Row,
  Col,
  Menu,
  MenuItem,
  Timeline,
  TimelineItem,
  Card
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueLazyload from "vue-lazyload";

//Menu,
// Submenu,
// MenuItem,
// MenuItemGroup,

Vue.config.productionTip = false;

Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Row);
Vue.use(Col);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Card);

Vue.use(VueLazyload, {
  preLoad: 1.2,
  error: "src/error.png",
  loading: require("@/assets/loading.png"),
  attempt: 1
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
